export default "__VITE_PUBLIC_ASSET__cb4d9d2c__"